import React from "react";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import menuIcon from "../../../../../assets/images/DeathModuleNew/more_horiz.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import addNewIcon from "../../../../../assets/SVGs/add.svg";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../../disability/DisabilityDashboard/styles/disbilityDashboardStyle.css";

export const DivorceCheckList = ({
  step,
  fileUpload,
  loading,
  documents,
  moduleData,
  width,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const detailList = [
    {
      name: "Audio / Video Message",
    },
    { name: "Contact List" },
    { name: "Important Document" },
    { name: "List of Large Bills" },
  ];

  return (
    <div
      className="DisabilityCardMain"
      style={{
        position: "relative",
        width: width ? width : "",
        height:" 100%",
      }}
    >
      <div className="cardHeadingDisability">
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {moduleData.Icon && (
            <img
              width={66}
              height={56}
              src={moduleData.Icon}
              alt={moduleData.name}
            ></img>
          )}
          {moduleData.name}
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/divorce");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      {moduleData.Purpose && (
        <div className="cardDisabilityDesc">{moduleData.Purpose}</div>
      )}
      <div className="disaaster-DashboardListing"
        style={{ maxHeight: "100%", overflowY: "auto", paddingInline: "8px" }}
      >
        {detailList &&
          detailList.length > 0 &&
          detailList.map((item, index) => (
            <div key={index} className="disaaster-DashboardListingRow">
              <div className="checkListName">
                {item.name ? item.name : "N/A"}
              </div>
              <div className="disaster-row-inner-style">
              <div className="row-Status">
              Completed
              </div>
              <div
                className="emailStatus"
                style={{ background: "transparent", width: "fit-content" }}
              >
                <img src={menuIcon} alt="more"></img>
              </div>
              </div>
            </div>
          ))}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
